export default "__VITE_ASSET__CWJoFqs6__"